export default __webpack_public_path__ + "static/Speedee_W_Bd-4b2634b7bc5b11d1ffe1424452827cd1.woff";